/**
 * This enum represent the type documents names to accept for client.
 */
export enum TypeDocumentNames {
    TERMS_CONDITIONS = 'TermsAndConditions',
    DATA_PROCESSING = 'DataProcessing',
    FREE_DEMO = 'FreeDemo',
}

export const NOMINA_EN_LINEA_PRODUCT = 'NominaEnLinea';
export const NOMINA_ELECTRONICA_PRODUCT = 'NominaElectronica';

export const ALL_PPRODUCT_NAMES = [NOMINA_EN_LINEA_PRODUCT, NOMINA_ELECTRONICA_PRODUCT];

export const DOCUMENT_DOWNLOAD_NAMES: { [key: string]: string } = {
    [TypeDocumentNames.TERMS_CONDITIONS]: process.env.REACT_APP_NAME_DOCUMENT_TyC ?? 'Terminos y Condiciones AEL',
    [TypeDocumentNames.DATA_PROCESSING]: process.env.REACT_APP_NAME_DOCUMENT_POLICT_DATA ?? 'Tratamiento Datos AEL',
    [TypeDocumentNames.FREE_DEMO]: process.env.REACT_APP_NAME_DOCUMENT_FREE_DEMO ?? 'Declaración de uso gratuito AEL',
};

/**
 * This enum represent all the steps when the client is registering.
 */
export enum OnboardingStepsUser {
    COMPANY_DATA = 0,
    POLITICAL_DATA = 1,
    DUEDILIGENCE = 2,
    TERMS_CONDITIONS = 3,
    HOME = 5,
    REJECT = 6,
    PLANS = 8,
}

/**
 * Constant to represent the names of the documents.
 */
export const NAME_DOCUMENTS: { [key: string]: string } = {
    [TypeDocumentNames.TERMS_CONDITIONS]: process.env.REACT_APP_NAME_DOCUMENT_TyC ?? 'Terminos y Condiciones AEL',
    [TypeDocumentNames.DATA_PROCESSING]: process.env.REACT_APP_NAME_DOCUMENT_POLICT_DATA ?? 'Politica Tratamiento Datos AEL',
};

export const SUPPORT_USER_ROLE = 'support';

export const REFUSED = 'rechazada';
export const APPROVED = 'aprobada';
